export const inp = "w-full px-4 py-2.5 rounded-xl bg-wyd-bg border border-white/10 text-white focus:ring-2 focus:ring-wyd-accent focus:outline-none";

export const Inp = ({ label, children }) => (
  <div><label className="overline text-wyd-muted block mb-1.5">{label}</label>{children}</div>
);

export const IconBtn = ({ testid, onClick, className = "", children, label }) => (
  <button data-testid={testid} onClick={onClick} aria-label={label}
    className={`w-9 h-9 grid place-items-center rounded-lg transition-colors duration-200 ${className}`}>
    {children}
  </button>
);

export const Group = ({ title, count, testid, empty, children }) => (
  <div className="mb-10" data-testid={testid}>
    <div className="flex items-baseline gap-3 mb-4">
      <h3 className="font-display font-bold text-lg">{title}</h3>
      <span className="text-sm text-wyd-muted">{count}</span>
    </div>
    {count === 0 ? <p className="text-wyd-muted text-sm py-6 px-4 rounded-xl border border-dashed border-white/10">{empty}</p>
      : <div className="space-y-3">{children}</div>}
  </div>
);

export const StatCard = ({ label, value, active, onClick, testid, accent }) => (
  <button data-testid={testid} onClick={onClick}
    className={`text-left rounded-2xl p-5 border transition-colors duration-200 ${active ? "bg-wyd-surface border-wyd-accent" : "bg-wyd-surface/50 border-white/10 hover:border-white/25"}`}>
    <div className="overline text-wyd-muted">{label}</div>
    <div className={`font-display font-black text-3xl mt-1 ${accent}`}>{value}</div>
  </button>
);
